import {useTranslation} from "react-i18next";
import {II18nMap} from "./en";
import { StringMap, TOptions } from "i18next";

export const useSSTranslation = (): {t: (key: keyof II18nMap, fallback: string, options?: string | TOptions<StringMap>) => string} => {
	const {t} = useTranslation();
	return {t};
}